import React from 'react';
import { Route } from 'react-router-dom';
import { ControlMappings } from '../pages';
import { ROUTES } from './routes';

export const ControlMappingsRoutes = () => {
  return (
    <Route exact path={`${ROUTES.CONTROL_MAPPINGS.path}`}>
      <ControlMappings />
    </Route>
  );
};
